import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import API from "../../api"
import Select from "react-select"
import { Row, Col, CardTitle, Label, Form, Button } from "reactstrap"
import { withRouter } from "react-router"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import FileDownload from "js-file-download"

const ExportEtudiant = props => {
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [active, setActive] = useState([
    { value: 0, label: "Non Actif" },
    { value: 1, label: "Actif" },
  ])
  const [selectActive, setSelectActive] = useState("")
  // Data Table
  const [orders, setOrders] = useState([])
  const [niveau, setNiveau] = useState([]);

  const [selectNiveau, setSelectNiveau] = useState("")
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Next",
    prePageText: "Back",
    sizePerPage : 50,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )

  const Columns = () => [
    {
      dataField: "cin",
      text: "CIN",
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nom",
      text: "Nom et prénom",
      sort: true,
      style: {
        textAlign: "center",
      },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group",
      text: "Groupe",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "semestre",
      text: "Semestre",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "mobile",
      text: "Téléphone",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
  ]

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }
  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  }

  const formatGroupLabel = data => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  )

  const { SearchBar } = Search
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  useEffect(async () => {
    const res = await API.post("etudiant/list_export",{annee_id}).then(res => {
      setOrders(res.data.etudiants)
    })
    const resS = await API.get("specialite/get_by_diplomes").then(resS => {
      setSpecialite(resS.data.Specialite)
    })
    const resNiveau = await API.get("niveau/select").then(resNiveau => {
      setNiveau(resNiveau.data.Niveau)
    })
    const resC = await API.get("cycle/select").then(resC => {
      setCycle(resC.data.Cycle)
    })
  }, [])
  const search = async () => {
    setOrders([])
    const specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0;
    if (selectGroupe != "") {
      var groupe = selectGroupe
    } else {
      var groupe = 0
    }
    const active = selectActive !== "" && selectActive != null ? selectActive.value : 0;
    const niveau_id = selectNiveau !== "" && selectNiveau != null ? selectNiveau.value : 0;
    const cycle_id = selectCycle !== "" && selectCycle != null ? selectCycle.value : 0;
    const semestre_id = selectSemestre !== "" && selectSemestre != null ? selectSemestre.value : 0;
    const res = await API.post("etudiant/search", {
      specialite_id: specialite_id,
      groups: groupe,
      active: active,
      cycle_id,
      niveau_id,
      annee_id,
      semestre_id
    }).then(res => {
      setOrders(res.data.etudiants)
    })
  }
  const searchAll = async () => {
    const res = await API.post("etudiant/list_export",{annee_id}).then(res => {
      setOrders(res.data.etudiants)
    })
  }
  const upload = async () => {
    const active = selectActive !== "" && selectActive != null ? selectActive.value : 0;
    const specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0;
    const niveau_id = selectNiveau !== "" && selectNiveau != null ? selectNiveau.value : 0;
    const cycle_id = selectCycle !== "" && selectCycle != null ? selectCycle.value : 0;
    const semestre_id = selectSemestre !== "" && selectSemestre != null ? selectSemestre.value : 0;
    if (selectGroupe != "") {
      var groupe = selectGroupe
    } else {
      var groupe = 0
    }
    const res = await API.post(
      "etudiant/export",
      {
        specialite_id: specialite_id,
        groups: groupe,
        active: active,
        niveau_id,
        cycle_id,
        annee_id,
        semestre_id
      },
      { responseType: "blob" }
    ).then(res => {
      FileDownload(res.data, "etudiants.xlsx")
    })
  }
  const getNiveau = async event => {
    var cycle_id = event.value
    setSelectCycle(event)
    setSelectNiveau("")
    setSelectSpecialite("")
    setSelectGroupe("")
    if (cycle_id == 1) {
      const res = await API.get("niveau/select").then(res => {
        setNiveau(res.data.Niveau)
      })
    } else {
      const res = await API.get("niveau/select_mastere").then(res => {
        setNiveau(res.data.Niveau)
      })
    }
  }
  const getSpec = async event => {
    var niveau_id = event.value
    setSelectSpecialite("")
    setSelectGroupe("")
    setSelectNiveau(event)
    const res = await API.post("specialite/get_by_niveau", {
      niveau_id: niveau_id,
      cycle_id: selectCycle.value,
    }).then(res => {
      setSpecialite(res.data.specialite)
    })
  }
  const getGroupe = async event => {
    var specialite_id = event.value
    setSelectSpecialite(event)
    setSelectGroupe("")
    const res = await API.post("group/getbysp", {
      specialite_id: specialite_id,
      cycle_id: selectCycle.value,
      niveau_id: selectNiveau.value,
      annee_id
    }).then(res => {
      setGroupe(res.data.groups)
    })
  }
  return (
    <React.Fragment>
      <div>
        <CardTitle style={{ color: "#556ee6" }} className="h4">
          Critéres de Recherches
        </CardTitle>
        <Form className="mt-4">
          <Row>
            <Col lg="4">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Semestre : </Label>
                <Select
                  options={semestre}
                  isSearchable={true}
                  value={selectSemestre}
                  onChange={e => setSelectSemestre(e)}
                />
              </div>
            </Col>
            <Col lg="4">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Cycle : </Label>
                <Select
                  options={cycle}
                  isSearchable={true}
                  value={selectCycle}
                  onChange={e => getNiveau(e)}
                />
              </div>
            </Col>
            <Col lg="4">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Niveau : </Label>
                <Select
                  options={niveau}
                  isSearchable={true}
                  value={selectNiveau}
                  onChange={e => getSpec(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Spécialité :</Label>
                <Select
                  options={specialite}
                  isSearchable={true}
                  value={selectSpecialite}
                  onChange={e => getGroupe(e)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Groupe : </Label>
                <Select
                  options={groupe}
                  isSearchable={true}
                  value={selectGroupe}
                  onChange={e => setSelectGroupe(e)}
                />
              </div>
            </Col>
          </Row>
        </Form>
        <div
          className="mb-4"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          {" "}
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={search}
              >
                Rechercher
              </button>
            </div>
          </Col>
          <Col lg="6">
            <div className="text-center mt-4">
              <button
                type="button"
                style={{ backgroundColor: "#761C19", borderColor: "#761C19" }}
                className="btn btn-success mb-2 me-2"
                onClick={searchAll}
              >
                Afficher Tout
              </button>
            </div>
          </Col>
        </div>
        <Row>
          <Col xs="12">
            <ToolkitProvider
              keyField="id"
              data={orders}
              columns={Columns()}
              search
              bootstrap4
            >
              {toolkitProps => (
                <div>
                  <Row className="mb-2">
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        <Button
                          type="button"
                          color="success"
                          className="btn  mb-2 me-2"
                          onClick={upload}
                        >
                          <i className="fas fa-file-export me-1" />
                          Export
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    noDataIndication={() => <NoDataIndication />}
                    striped={false}
                    bordered={false}
                    classes={"table align-middle table-nowrap"}
                    headerWrapperClasses={"table-light"}
                    hover
                    pagination={paginationFactory(pageOptions)}
                    {...toolkitProps.baseProps}
                  />
                </div>
              )}
            </ToolkitProvider>
          </Col>
        </Row>
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(ExportEtudiant)
ExportEtudiant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
}
